import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'

import RenderField from 'components/RenderField/RenderFieldContainer'

const AnimatedLabelField = ({
  label = 'label',
  validate,
  prefix = '',
  parentHandleChange = null,
  ...props
}) => {
  const [hideLabel, setHideLabel] = useState(true)
  const [field, setField] = useState(null)

  const handleChange = e => {
    if (parentHandleChange) {
      parentHandleChange(e)
    }
    setHideLabel(!e.currentTarget.value)
  }

  useEffect(() => {
    if (field) {
      setHideLabel(false)
    }
  }, [])

  return (
    <Field
      prefix={prefix}
      label={label}
      ref={input => setField(input)}
      hideLabel={hideLabel}
      placeholder={label}
      onChange={e => handleChange(e)}
      component={RenderField}
      validate={validate}
      {...props}
    />
  )
}

AnimatedLabelField.prototype = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  validate: PropTypes.array,
  prefix: PropTypes.string,
  parentHandleChange: PropTypes.func,
}

export default AnimatedLabelField
